





































import {
  defineComponent,
  onMounted,
  ref,
  useContext,
} from '@nuxtjs/composition-api';
import { SfImage, SfLink, SfSection } from '@storefront-ui/vue';

import { useUiHelpers } from '~/composables';
import { useCategorySearch } from '~/modules/catalog/category/composables/useCategorySearch';

export default defineComponent({
  name: 'ReducedProducts',
  components: {
    SfSection,
    SfImage,
    SfLink,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { getCatLink } = useUiHelpers();
    const { search } = useCategorySearch();
    const categories = ref([]);
    const {
      $config: { currentSite },
    } = useContext();
    const CN_CATEGORY_ID = [
      '525',
      '530',
      '527',
      '526',
      '529',
      '528',
      '533',
      '542',
      '722',
    ];
    const UK_CATEGORY_ID = [
      '42',
      '47',
      '44',
      '43',
      '50',
      '46',
      '55',
      '260',
      '48',
      '663',
    ];
    onMounted(async () => {
      categories.value = await search({
        filters: {
          ids: {
            in: currentSite === 'cn' ? CN_CATEGORY_ID : UK_CATEGORY_ID,
          },
        },
        customQuery: {
          categorySearch: 'category-shopby-custom-query',
        },
      });
      // console.log('categories', categories);
    });
    return {
      getCatLink,
      categories,
    };
  },
});
